// Maps options for generic.click and generic.event into the correct format
import tcEventsList from './tagCommanderSpecificEvents';

const getGenericOptions = (props) => {
    const {
        category, action, label, value, highfrequency, qualifiedsegment, referrer, ...others
    } = props;

    const options = {};

    if (category) {
        options.eventcategory = category;
    }

    if (action) {
        options.eventaction = action;
    }

    if (label) {
        options.eventlabel = label;
    }

    if (value) {
        options.eventvalue = value;
    }

    if (typeof highfrequency === 'boolean') {
        // All edap properties must be strings :(
        options.highfrequency = highfrequency.toString();
    }
    if (qualifiedsegment) {
        options.qualifiedsegment = qualifiedsegment;
    }
    if (referrer) {
        options.referrer = referrer;
    }

    return { ...options, ...others };
};

const pageUnload = (props = {}) => {
    const options = getGenericOptions(props);
    const pUnload = 'page.unload';
    edap.trigger(pUnload, options);
    ha.userTiming.mark(pUnload);
};

const pageLoad = (pageName, props = {}) => {
    const options = getGenericOptions(props);
    edap.trigger('edap.flush');
    analyticsdatalayer.pagename = pageName;
    tc_vars.pagename = pageName;
    tc_vars.event_page_name = pageName;
    edap.trigger('pageview', options);
    tcEventsList.pageview(pageName);
    ha.userTiming.mark('primary.action.rendered');
};

const genericClick = (props) => {
    const options = getGenericOptions(props);
    edap.trigger('generic.click', options);
};

const genericEvent = (props) => {
    const options = getGenericOptions(props);
    edap.trigger('generic.event', options);
};

const userAccountCreated = (props) => {
    const defaultProps = {
        loginsource: 'ulx',
        logintype: 'email',
        newusertype: 'supplier'
    };
    const options = { ...defaultProps, ...props };
    edap.trigger('user.account.created', options);
    tcEventsList.userAccountCreated(options);
};

const listingOnboardingStarted = (options) => {
    edap.trigger('listing.onboarding.started', options);
};

const testExposure = (expdata) => {
    edap.trigger('test.exposure', {
        testname: `${expdata.name}:${expdata.instanceId}`, // All names are lowercase for edap
        variant: `${expdata.value}`
    });
};

export default {
    pageUnload,
    pageLoad,
    getGenericOptions,
    genericClick,
    genericEvent,
    userAccountCreated,
    listingOnboardingStarted,
    testExposure
};
